// extracted by mini-css-extract-plugin
export default {"navCl":"Navigation_navCl__luRKi","linkCl":"Navigation_linkCl__-gwhU","active":"Navigation_active__ZAj05"};